export enum AppPermissions {
  ApproveTermSheet = 'approve_termsheet',
  RejectTermSheet = 'reject_termsheet',
  ApproveFeeLetter = 'approve_feeletter',
  RejectFeeLetter = 'reject_feeletter',
  ApproveLOI = 'approve_loi',
  RejectLOI = 'reject_loi',
  ApproveAgreement = 'approve_agreement',
  RejectAgreement = 'reject_agreement',
  ApproveInvoice = 'approve_invoice',
  RejectInvoice = 'reject_invoice',
  ViewLeads = "view_leads",
  DeleteLeads = "delete_leads",
  ViewLeadDetails = "view_lead_details",
  CreateLeads = "create_leads",
  UpdateVin = "update_vin",
  PipelineView = "pipeline_view",
  BulkImportLead = "lead_bulk_import",
  UpdateCustomerAnswers = "lead_update_customer_answers",
  UpdateBuyingInfluences = "lead_update_buying_influences",
  AssignSalesPerson = "lead_assign_sales_person",
  AssignIntercityUser = "lead_assign_intercity_user",
  CanUpdateIntercityUser = "lead_update_intercity_user",
  CanUpdateSalesPerson = "lead_update_sales_person",
  AssignLeadManager = "lead_assign_manager",
  CanUpdateLeadManager = "lead_update_manager",
  AssignGroupManager = "lead_assign_group_manager",
  CanUpdateGroupManager = "lead_update_group_manager",
  AssignTelecaller = "lead_assign_telecaller",
  CanUpdateTelecaller = "lead_update_telecaller",
  AssignCRMAgent = "lead_assign_crm_agent",
  CanUpdateCrmAgent = "lead_update_crm_agent",
  BulkAssignLeads = "lead_bulk_assign",
  LinkLead = "link_lead",
  UnlinkLead = "unlink_lead",
  UpdateLeadSettings = "update_lead_settings",
  ScheduleTestDrive = "schedule_test_drive",
  ScheduleShowroomVisit = "schedule_showroom_visit",
  RequestCallBack = "request_call_back",
  AddVehicleToLead = "lead_add_vehicle",
  UpdateLeadVehicle = "lead_update_vehicle",
  SetLeadQuality = "set_lead_quality",
  ConvertToEnquiry = "convert_to_enquiry",
  canArchivedLeads = "archive_lead",
  viewArchivedLeads = "view_archived_lead",
  MapTags = "map_tags",
  SetLeadClosingDate = "set_lead_closing_date",
  CloseDeal = "close_deal",
  MarkLost = "mark_lost",
  UpdateLeadShowroom = "update_lead_showroom",
  View360 = "view_lead_customer_360",
  ViewLeadActivities = "view_lead_activities",
  CreateLeadActivity = "create_lead_activity",
  UpdateLeadActivity = "update_lead_activity",
  ModifyActivityStatus = "modify_activity_status",
  ViewActivityCalendar = "view_activity_calendar",
  ViewVehicleActivityCalendar = "view_vehicle_activity_calendar",
  ViewActivityList = "view_activity_list",
  ReserveTime = "reserve_time",
  CancelActivity = "cancel_activity",
  DeleteActivity = "delete_activity",
  ViewActivity = "view_activity_details",
  ViewTimeOffs = "view_timeoffs",
  DownloadLeads = "download_leads",
  DownloadOpportunity = "download_opportunity",
  DownloadCustomers = "download_customers",
  DownloadVehicles = "download_vehicles",
  UpdateGeneralSettings = "update_general_settings",
  ManageServiceAdvisorSettings = "manage_service_advisor_settings",
  ManageBodyShopSettings = "manage_body_shop_settings",
  ManageCheckList = "manage_checklist",
  ViewOcrSettings = "view_ocr_settings",
  ViewContentSettings = "view_content_settings",
  CreateStaffMembers = "create_staff_members",
  UpdateStaffMembers = "update_staff_members",
  ViewStaffMembers = "view_staff_members",
  DeleteStaffMembers = "delete_staff_members",
  ViewBusinessSource = "view_business_source",
  CreateBusinessSource = "create_business_source",
  UpdateBusinessSource = "update_business_source",
  DeleteBusinessSource = "delete_business_source",
  CreateBuyingInfluence = "create_buying_influence",
  UpdateBuyingInfluence = "update_buying_influence",
  DeleteBuyingInfluence = "delete_buying_influence",
  ViewBuyingInfluence = "view_buying_influence",
  ViewCustomer = "view_customer",
  ViewAllCustomers = "view_all_customers",
  SearchCustomer = "search_customer",
  ViewCustomerAddress = "view_customer_address",
  ViewCustomerDetails = "view_customer_details",
  CreateCustomer = "create_customer",
  UpdateCustomerContacts = "update_customer_contacts",
  UpdateCustomerDemographics = "update_customer_demographics",
  UpdateCustomerExperiences = "update_customer_experiences",
  UpdateCustomerDocuments = "update_customer_documents",
  CustomerSocialMediaDetails = "customer_social_media_details",
  UpdateVehicleUserDetails = "update_vehicle_user_details",
  UpdateCustomerPreferredTimes = "update_customer_preferred_times",
  UpdateCustomerPartnerInfo = "update_customer_partner_info",
  UnlinkCustomerPhone = "unlink_customer_phone",
  ManageCampaignPages = "manage_campaign_pages",
  ViewCampaigns = "view_campaigns",
  CreateCampaigns = "create_campaigns",
  UpdateCampaigns = "update_campaigns",
  ManageCampaignForms = "manage_campaign_forms",
  ManageCustomerSatisfactionLevel = "manage_customer_satisfaction_level",
  ManageCustomerSatisfactionReason = "manage_customer_satisfaction_reason",
  ViewInitialTouchpoint = "view_initial_touchpoint",
  ViewLeadSource = "view_lead_source",
  CreateInitialTouchpoint = "create_initial_touchpoint",
  UpdateInitialTouchpoint = "update_initial_touchpoint",
  DeleteInitialTouchpoint = "delete_initial_touchpoint",
  UpdateLeadIntent = "update_lead_intent",
  UpdateLeadNewness = "update_lead_newness",
  UpdateDecisionTimeFrame = "update_decision_timeframe",
  ViewLeadQuality = "view_lead_quality",
  CreateLeadQuality = "create_lead_quality",
  UpdateLeadQuality = "update_lead_quality",
  UpdateLeadTitle = "update_lead_title",
  DeleteLeadQuality = "delete_lead_quality",
  CreateBank = "create_bank",
  UpdateBank = "update_bank",
  DeleteBank = "delete_bank",
  CreateTag = "create_tag",
  UpdateTag = "update_tag",
  DeleteTag = "delete_tag",
  ViewLeadStatus = "view_lead_status",
  UpdateLeadStatus = "update_lead_status",
  ViewLeadType = "view_lead_type",
  CreateLeadType = "create_lead_type",
  UpdateLeadType = "update_lead_type",
  DeleteLeadType = "delete_lead_type",
  SaveFilter = "save_filter",
  RemoveFilter = "remove_filter",
  UpdateListColumnSettings = "update_list_column_settings",
  UpdateLeadAssignment = "update_lead_assignment",
  ViewStaffShifts = "view_staff_shifts",
  CreateStaffShift = "create_staff_shift",
  UpdateStaffShift = "update_staff_shift",
  DeleteStaffShift = "delete_staff_shift",
  CreateStaffTimeOff = "create_staff_timeoff",
  UpdateStaffTimeOff = "update_staff_timeoff",
  DeleteStaffTimeOff = "delete_staff_timeoff",
  ViewStaffTimeOffs = "view_staff_timeoffs",
  ViewShowroomShifts = "view_showroom_shifts",
  CreateShowroomShift = "create_showroom_shift",
  UpdateShowroomShift = "update_showroom_shift",
  DeleteShowroomShift = "delete_showroom_shift",
  ViewShowrooms = "view_showrooms",
  CreateShowrooms = "create_showrooms",
  UpdateShowrooms = "update_showrooms",
  DeleteShowrooms = "delete_showrooms",
  ApproveVinRequest = "approve_vin_request",
  ViewVinRequests = "view_vin_requests",
  ViewAllRequests = "view_all_requests",
  ViewVinReservedAdditionalDetails = "view_vin_reserved_additional_details",
  RejectVinRequests = "reject_vin_requests",
  CancelVinRequests = "cancel_vin_requests",
  ReleaseVinRequests = "release_vin_requests",
  ExtendVinRequests = "extend_vin_requests",
  ViewBookedVehicles = "view_booked_vehicles",
  ViewTestdriveVehicles = "view_testdrive_vehicles",
  ViewPreBookingVINS = "view_pre_booking_vin",
  CreateTestdriveVehicles = "create_testdrive_vehicles",
  UpdateTestdriveVehicles = "update_testdrive_vehicles",
  DeleteTestdriveVehicles = "delete_testdrive_vehicles",
  SyncAutolineCustomer = "sync_autoline_customer",
  ViewVehicles = "view_vehicles",
  ViewVehicleVariant = "view_vehicle_variant",
  UpdateVehicleVariant = "update_vehicle_variant",
  ViewVinData = "view_vin_data",
  tenancyExpiryTracker = 'view_tenant_history',
  ViewVisiblityGroup = "view_visibility_group",
  CreateVisiblityGroup = "create_visibility_group",
  DeleteVisiblityGroup = "delete_visibility_group",
  UpdateConfigurationDiscount = "update_configuration_discount",
  WithoutPaymentMethod = "use_without_payment_method",
  ViewConfigurationReport = "view_configuration_report",
  ViewEmailReport = "view_email_report",
  DownloadEmailReport = "download_email_report",
  DownloadConfigurationReport = "download_configuration_report",
  // Trade-In
  ViewTradeIn = "view_trade_in",
  WithdrawTradeInEvaluation = "withdraw_trade_in_evaluation",
  ProcessTradeIn = "process_trade_in",
  ApproveTradeIn = "approve_trade_in",
  HoldTradeIn = "hold_trade_in",
  RejectTradeInByCustomer = "reject_trade_in_by_customer",
  RejectTradeInByEvaluator = "reject_trade_in_by_evaluator",
  AttachTradeIn = "attach_trade_in",
  DetachTradeIn = "detach_trade_in",
  SendTradeInReminder = "send_trade_in_reminder",
  RequestForTradeInNegotiation = "request_for_trade_in_negotiation",
  ApplyTradeInAssist = "apply_trade_in_assist",
  AddTradeInExteriorColor = "add_trade_in_exterior_color",
  UpdateTradeInExteriorColor = "update_trade_in_exterior_color",
  DeleteTradeInExteriorColor = "delete_trade_in_exterior_color",
  AddTradeInInteriorColor = "add_trade_in_interior_color",
  UpdateTradeInInteriorColor = "update_trade_in_interior_color",
  DeleteTradeInInteriorColor = "delete_trade_in_interior_color",
  // Finance
  ViewFinance = "view_finance",
  ProcessFinance = "process_finance",
  WithdrawFinance = "withdraw_finance",
  RejectFinance = "reject_finance",
  HoldFinance = "hold_finance",
  AttachFinance = "attach_finance",
  DetachFinance = "detach_finance",
  SendFinanceReminder = "send_finance_reminder",
  // Roles
  ViewRoles = "view_roles",
  UpdateRoles = "update_roles",
  AddRoles = "add_roles",
  DeleteRoles = "delete_roles",
  ViewActivitySummaryReport = "view_report",
  DownloadReport = "download_report",
  ViewDailySalesReportStaff = "view_daily_sales_report_staff",
  ViewDailySalesReportVehicle = "view_daily_sales_report_vehicle",
  ViewLeadConversionReport = "view_lead_conversion_report",
  ViewFollowupReport = "view_followup_report",
  ViewActivitySummaryReportStaff = "view_actvity_summary_report_staff",
  ViewActivitySummaryReportVehicle = "view_actvity_summary_report_vehicle",
  ViewCollectionSegregationReport = "view_collection_segregation_report",
  ViewLostLeadReportStaff = "view_lost_lead_report_staff",
  ViewLostLeadReportVehicle = "view_lost_lead_report_vehicle",
  ViewLostLeadComparisonByActivity = "view_lost_lead_comparison_activity",
  ViewLostLeadComparisonByShowroom = "view_lost_lead_comparison_showroom",
  ViewCallActivityReportStaff = "view_call_activity_report_staff",
  ViewTestdriveActivityReportStaff = "view_testdrive_activity_report_staff",
  ViewShoowroomVisitActivityReportStaff = "view_showroom_visit_activity_report_staff",
  ViewConfigurationActivityReportStaff = "view_configuration_activity_report_staff",
  ViewQuotationActivityReportStaff = "view_quotation_activity_report_staff",
  ViewBookingActivityReportStaff = "view_booking_activity_report_staff",
  ViewOrderActivityReportStaff = "view_order_activity_report_staff",
  ViewTradeinActivityReportStaff = "view_tradein_activity_report_staff",
  ViewDeliveryActivityReportStaff = "view_delivery_activity_report_staff",
  ViewCallActivityReportVehicle = "view_call_activity_report_vehicle",
  ViewTestdriveActivityReportVehicle = "view_testdrive_activity_report_vehicle",
  ViewShoowroomVisitActivityReportVehicle = "view_showroom_visit_activity_report_vehicle",
  ViewConfigurationActivityReportVehicle = "view_configuration_activity_report_vehicle",
  ViewQuotationActivityReportVehicle = "view_quotation_activity_report_vehicle",
  ViewBookingActivityReportVehicle = "view_booking_activity_report_vehicle",
  ViewOrderActivityReportVehicle = "view_order_activity_report_vehicle",
  ViewTradeinActivityReportVehicle = "view_tradein_activity_report_vehicle",
  ViewDeliveryActivityReportVehicle = "view_delivery_activity_report_vehicle",
  ViewConsolidatedActivityReport = "view_consolidated_activity_report",
  ViewSpecialBookingRequests = "view_special_booking_requests",
  RequestSpecialBooking = "request_special_booking",
  ApproveSpecialBooking = "approve_special_booking",
  RejectSpecialBooking = "reject_special_booking",
  CreateDiscountType = "create_discount_type",
  UpdateDiscountType = "update_discount_type",
  DeleteDiscountType = "delete_discount_type",
  CreateDiscountDocumentType = "create_discount_document_type",
  UpdateDiscountDocumentType = "update_discount_document_type",
  DeleteDiscountDocumentType = "delete_discount_document_type",
  ViewCashDiscounts = "view_cash_discounts",
  CreateCashDiscounts = "create_cash_discounts",
  UpdateCashDiscounts = "update_cash_discounts",
  DeleteCashDiscounts = "delete_cash_discounts",
  DownloadStaffMembers = "download_staff_members",
  CreateOrderCancellationReason = "create_order_cancel_reason",
  DeleteOrderCancellationReasons = "delete_order_cancel_reason",
  UpdateOrderCancellationReasons = "update_order_cancel_reason",
  UpdateBlockingReasons = "update_customer_blocking_reason",
  CreateBlockingReason = "create_customer_blocking_reason",
  DeleteBlockingReasons = "delete_customer_blocking_reason",
  BlockingCustomer = "blocking-customer",

  CreateLeadAssigneeChangeReason = "create_lead_assignee_change_reason",
  DeleteLeadAssigneeChangeReasons = "delete_lead_assignee_change_reason",
  UpdateLeadAssigneeChangeReason = "update_lead_assignee_change_reason",

  ViewLostRequest = "view_lost_request",
  ApproveLostRequest = "approve_lost_request",
  RejectLostRequest = "reject_lost_request",
  UpdateVehicleModelImage = "update_vehicle_model_image",
  // discount
  ApplyDiscount = "apply_discount",
  ApproveDiscount = "approve_discount",
  RejectDiscount = "reject_discount",
  ActivateDiscount = "activate_discount",
  DeactivateDiscount = "deactivate_discount",
  DeleteDiscount = "delete_discount",
  ViewPoolDiscounts = "view_pool_discounts",
  CreatePoolDiscounts = "create_pool_discounts",
  UpdatePoolDiscounts = "update_pool_discounts",
  DeletePoolDiscounts = "delete_pool_discounts",
  CreateNetPriceCeiling = "create_npc",
  UpdateVehicleNetPriceCeiling = "update_vehicle_npc",
  ViewNetPriceCeiling = "view_vehicle_npc",
  // cancel configuration

  ViewBdcReport = "view_bdc_report",

  ViewTradeInDiscounts = "view_tradeIn_discounts",
  CreateTradeInDiscounts = "create_tradeIn_discounts",
  UpdateTradeInDiscounts = "update_tradeIn_discounts",
  DeleteTradeInDiscounts = "delete_tradeIn_discounts",

  CreatePrebookingAvailability = "create_pre_booking_availability",
  ApprovePreBookingAvailability = "approve_pre_booking_availability",
  ViewListingPrice = "view_listing_price",
  ViewPreBookingCombinations = "view_pre_booking_combinations",

  CreateDistrict = "create_district",
  UpdateDistrict = "update_district",
  DeleteDistrict = "delete_district",
  CreateGovernorate = "create_governorate",
  UpdateGovernorate = "update_governorate",
  DeleteGovernorate = "delete_governorate",
  ViewStaffTarget = "view_staff_target",
  CreateStaffTarget = "create_staff_target",
  UpdateStaffTarget = "update_staff_target",
  DeleteStaffTarget = "delete_staff_target",
  ViewHiddenVehicles = "view_hidden_vehicles",
  ViewInvisibleVehicles = "view_invisible_vehicles",
  UpdateInvisibleVehicles = "update_invisible_vehicles",
  DownloadCampaignSummary = "download_campaign_summary",
  ViewInactiveVehicles = "view_inactive_vehicles",
  ImportVinSaleDate = "import_vin_sale_date",
  ImportVinDiscount = "vehicle_discount_bulk_update",
  ImportVinPrices = "import_vin_prices",
  ImportDeliveryStatusDiscount = "vehicle_delivery_status_bulk_update",
  DiscountSummaryReport = "discount_summary_report",
  ApplyAccessoryDiscount = "apply_accessory_discount",
  ApproveAccessoryDiscount = "approve_accessory_discount",
  RejectAccessoryDiscount = "reject_accessory_discount",
  ActivateAccessoryDiscount = "activate_accessory_discount",
  DeactivateAccessoryDiscount = "deactivate_accessory_discount",
  DeleteAccessoryDiscount = "delete_accessory_discount",
  ForceLogoutStaff = "force_logout_staff",
  ViewCombinedDiscounts = "view_combined_discounts",
  CreateCombinedDiscounts = "create_combined_discounts",
  UpdateCombinedDiscounts = "update_combined_discounts",
  DeleteCombinedDiscounts = "delete_combined_discounts",
  CloneCashDiscounts = "clone_cash_discounts",
  ClonePoolDiscounts = "clone_pool_discounts",
  CloneTradeInDiscounts = "clone_tradeIn_discounts",
  BulkUpdateVehicleStatus = "vehicle_status_bulk_update",
  UpdateVehicleStatusIndividual = "individual_vehicle_status_update",
  MapAccessories = "map_accessories",
  AddVehicleModels = "create_vehicle_model",
  SyncAutolineVehicleStatus = "sync_autoline_vehicle_status",

  ReSyncInvoice = "re_sync_invoice",
  ViewMonthEndClosingDetails = "view_month_end_closing_details",
  CreateMonthEndClosing = "create_month_end_closing",
  DownLoadMonthEndClosing = "download_month_end_closing",
  CreatePreBooking = "create_pre_booking",
  CreatePreBookingAvailabilityRejectReason = "create_pre_booking_availability_reject_reason",
  UpdatePreBookingAvailabilityRejectReason = "update_pre_booking_availability_reject_reason",
  DeletePreBookingAvailabilityRejectReason = "delete_pre_booking_availability_reject_reason",
  PreVinBulkUpdateStatus = "bulk_update_pre_vin",
  PreVinDownloadStatus = "download_pre_vin",
  CreateOtherDiscountType = "create_other_discount_type",
  UpdateOtherDiscountType = "update_other_discount_type",
  DeleteOtherDiscountType = "delete_other_discount_type",
  AddExcessAmountAdjustmentType = "add_excess_amount_adjustment_type",
  UpdateExcessAmountAdjustmentType = "update_excess_amount_adjustment_type",
  DeleteExcessAmountAdjustmentType = "delete_excess_amount_adjustment_type",
  AddTradeInPhysicalLocation = "add_trade_in_physical_location",
  UpdateTradeInPhysicalLocation = "update_trade_in_physical_location",
  DeleteTradeInPhysicalLocation = "delete_trade_in_physical_location",
  AddTradeInSettlementFinanceOwingBank = "add_trade_in_finance_owing_bank",
  UpdateTradeInSettlementFinanceOwingBank = "update_trade_in_finance_owing_bank",
  DeleteTradeInSettlementFinanceOwingBank = "delete_trade_in_finance_owing_bank",
  AddInvoiceCancellationReason = "add_invoice_cancellation_reason",
  UpdateInvoiceCancellationReason = "update_invoice_cancellation_reason",
  DeleteInvoiceCancellationReason = "delete_invoice_cancellation_reason",
  UpdateCustomerName = "update_customer_name",

  RequestOrUploadOcrRecords = "request_or_upload_ocr_records",
  AdminReviewOcrRecords = "admin_review_ocr_records",
  GCReviewOcrRecords = "gc_review_ocr_records",
  BulkUploadOcrRecords = "bulk_upload_ocr_records",
  DownloadOcrRecords = "download_ocr_records",
  CompleteOcrRecords = "complete_ocr_records",
  GCApproveOcrRecords = "gc_approve_ocr_records",
  AdminApproveOcrRecords = "admin_approve_ocr_records",
  MoveOcrRecords = "move_ocr_records",
  //  Ocr Document Tag
  CreateOcrDocumentTag = "create_ocr_document_tag",
  UpdateOcrDocumentTag = "update_ocr_document_tag",
  DeleteOcrDocumentTag = "delete_ocr_document_tag",
  // List Price
  UploadListPrice = "upload_list_price",
  ApproveListPriceUploads = "approve_list_price_uploads",

  // List Price Upload reject reasons
  CreateListPriceUploadRejectReason = "create_list_price_upload_reject_reason",
  UpdateListPriceUploadRejectReason = "update_list_price_upload_reject_reason",
  DeleteListPriceUploadRejectReason = "delete_list_price_upload_reject_reason",
  ViewAccessoryReport = "view_accessory_report",
  ViewCouponReport = "view_coupon_report",
  ViewOcrRecords = "view_ocr_records",
  ViewInsuranceReport = "view_insurance_report",
  ViewServicePackageReport = "view_service_package_report",
  ViewBookingManipulationReport = "view_bookig_manipulation_report",
  ViewTransferLeadReport = "view_transfer_lead_report",
  ViewCustomerDataChangeReport = "view_customer_data_change_report",
  ApproveAccessoriesDiscountAmountBeyondSlab = "approve_accessories_aiscount_amount_beyond_slab",
  WhatsappReport = "whatsapp_report",
  PendingMKPayment = "pending_mk_payment",

  // Campaign
  CreateDiscountCampaign = "create_discount_campaign",
  ApproveDiscountCampaign = "approve_discount_campaign",
  UpdateDiscountCampaign = "update_discount_campaign",
  ViewDiscountCampaign = "view_discount_campaign",
  CloneDiscountCampaign = "clone_discount_campaign",
  DeleteDiscountCampaign = "delete_discount_campaign",

  // Holiday

  // CreateHoliday = 'create_holiday',
  // UpdateHoliday = 'update_holiday',
  // DeleteHoliday = 'delete_holiday',
  HolidaySettings = "holiday_settings",

  UpdateTraderVin = "update_trader_vin",

  // Sales Target
  CreateSalesTarget = "create_sales_target",
  ViewSalesTarget = "view_sales_target",

  InitiateTestDrive = "initiate_test_drive",

  UserbackSettings = "userback_settings",
  WhatsappLeadAssignmentSettings = "whatsapp_lead_assignment_settings",
  MergeLeads = "merge_leads",
  MergeCustomers = "merge_customers",
  MergeCompany = "merge_companies",

  // Requirement
  CompareRequirement = "compare_requirement",
  RequirementStatusApprove = "requirement_status_approve",
  RequirementStatusReject = "requirement_status_reject",
  RequirementStatusRevoke = "requirement_status_revoke",
  UpdateRequirement = "update_requirement",
  CreateRequirement = "create_requirement",
  ViewRequirement = "view_requirement",
  ViewRequirementList = "view_requirement_list",
  DeleteRequirement = "delete_requirement",
  ViewRequirementReason = "view_requirement_reason",
  CreateRequirementReason = "create_requirement_reason",
  CreateInvoiceReason = "create_requirement_reason",
  UpdateRequirementReason = "update_requirement_reason",
  DeleteRequirementReason = "delete_requirement_reason",
  RevertInvoicePaymentTransaction  = "revert_invoice_payment_transaction",

  // Proposal
  ViewProposalReason = "view_proposal_reason",
  CreateProposalReason = "create_proposal_reason",
  UpdateProposalReason = "update_proposal_reason",
  DeleteProposalReason = "delete_proposal_reason",

  // Amenity
  CreateAmenity = "create_amenity",
  UpdateAmenity = "update_amenity",
  DeleteAmenity = "delete_amenity",

  // CityLocation
  CreateCityLocation = "create_citylocation",
  UpdateCityLocation = "update_citylocation",
  DeleteCityLocation = "delete_citylocation",

  // CityZone
  CreateCityZone = "create_cityzone",
  UpdateCityZone = "update_cityzone",
  DeleteCityZone = "delete_cityzone",

  // City
  CreateCity = "create_city",
  UpdateCity = "update_city",
  DeleteCity = "delete_city",

  // Developer
  CreateDeveloper = "create_developer",
  UpdateDeveloper = "update_developer",
  DeleteDeveloper = "delete_developer",

  // Floor
  CreateFloor = "create_floor",
  UpdateFloor = "update_floor",
  DeleteFloor = "delete_floor",

  // ProjectType
  CreateProjectType = "create_projecttype",
  UpdateProjectType = "update_projecttype",
  DeleteProjectType = "delete_projecttype",

  // Project
  CreateProject = "create_project",
  UpdateProject = "update_project",
  DeleteProject = "delete_project",

  // PropertyType
  CreatePropertyType = "create_propertytype",
  UpdatePropertyType = "update_propertytype",
  DeletePropertyType = "delete_propertytype",

  // Property
  CreateProperty = "create_property",
  UpdateProperty = "update_property",
  DeleteProperty = "delete_property",

  // Unit
  CreateUnit = "create_unit",
  UpdateUnit = "update_unit",
  DeleteUnit = "delete_unit",

  // Doc Settings

  CreateDocumentCategory = "create_document_category",
  UpdateDocumentCategory = "update_document_category",
  DeleteDocumentCategory = "delete_document_category",

  CreateDocumentSubCategory = "create_document_sub_category",
  UpdateDocumentSubCategory = "update_document_sub_category",
  DeleteDocumentSubCategory = "delete_document_sub_category",

  CreateDocumentOwner = "create_document_owner",
  UpdateDocumentOwner = "update_document_owner",
  DeleteDocumentOwner = "delete_document_owner",

  CreateDocumentName = "create_document_name",
  UpdateDocumentName = "update_document_name",
  DeleteDocumentName = "delete_document_name",

  CreateLegalDueDiligence = "create_legal_due-diligence",
  UpdateLegalDueDiligence = "update_legal_due-diligence",
  DeleteLegalDueDiligence = "delete_legal_due-diligence",
  AcceptLegalDueDiligence = "accept_legal_due-diligence",
  RejectLegalDueDiligence = "reject_legal_due-diligence",

  // Reason
  CreateReason = "create_reason",
  UpdateReason = "update_reason",
  DeleteReason = "delete_reason",

  // Mask Contact
  MaskContacts = "mask_contacts",
  UnMaskContacts = "unmask_contacts",
  ViewMaskContacts = "view_masked_contacts",
  ViewAllMaskContacts = "view_all_masked_contacts",

  // Company 360
  AddCompanyDocuments = "add_company_documents",
  AddCompanyPeople = "add_company_people",
  CreateCompanyActivity = "create_company_activity",
  ViewCompanyActivities = "view_company_activities",
  ViewOccupancyInformation = "view_occupancy_information",
  ViewOurRelationship = "view_our_relationship",
  ViewCompanyDocuments = "view_company_documents",
  ViewCompanyOffices = "view_company_offices",
  ViewCompanyGroupCompanies = "view_company_group_companies",
  ViewCompanyPeople = "view_company_people",
  ViewCompanyInvoice = "view_company_invoice",
  ViewCompanyProposal = "view_company_proposal",
  ViewCompanyAgreement = "view_company_agreement",
  ViewCompanyRequirement = "view_company_requirement",
  ViewCompanyOpportunities = "view_company_opportunities",
  ViewCompanyLeads = "view_company_leads",
  ViewCompanyProfile = "view_company_profile",
  ViewCompany360 = "view_company_360",
  ViewTelecaller360 = "view_telecaller_360",
  ViewCompanyLogs = "view_company_logs",

  CreateCompany = "create_company",
  UpdateCompany = "update_company",
  DeleteCompany = "delete_company",
  ViewCompanyList = "view_company_list",
  UpdateCompanyDemographics = "update_company_demographics",
  UpdateCompanyDocuments = "update_company_documents",
  UpdateCompanySocialMediaDetails = "company_social_media_details",

  //
  CreateTenancy = "create_tenancy",
  ViewTenancy = "view_tenancy",
  UpdateTenancy = "update_tenancy",
  ViewProject = "view_project",
  CreateProposal = "create_proposal",
  UpdateProposal = "update_proposal",
  ApproveProposal = "approve_proposal",
  RejectProposal = "reject_proposal",
  EditCommercialDetails = "edit_commercial_details",
  ViewProposal = "view_proposal",
  ViewProperty = "view_property",

  ViewOpportunity ='view_opportunity',

  ViewTransaction360 ='view_transaction360',

  // special Approvals
  ViewInvoicesForApprovals = 'view_invoices_for_approvals',
  ViewProposalsForApprovals = 'view_proposals_for_approvals',
  ViewTermsheetsForApprovals = 'view_term_sheets_for_approvals',
  ViewFeelettersForApprovals = 'view_fee_letters_for_approvals',
  ViewLetterofIntentForApprovals = 'view_letter_of_intents_for_approvals',
  ViewAgreementForApprovals = 'view_agreements_for_approvals',

  CreateCustomerWithoutContacts = 'create_customer_without_contacts',
}
